import { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import AOS from 'aos';
import 'swiper/css';

import { initAnalyticsTracking, trackPageView } from 'helpers/analyticsTracker';

import Routes from './routes/Routes';


import { configureFakeBackend } from './helpers';
import './index.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {

    const location = useLocation();


    useEffect(() => {
        AOS.init();
        initAnalyticsTracking();
    }, []);

    useEffect(() => {
        trackPageView(location.pathname);   // ⭐ Track route changes
    }, [location.pathname]);

    configureFakeBackend()
    return (<>
        <Routes />
        <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
    </>)
};

export default App;
